var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { renderInternalEvents } from "../renderInternalEvents";
import { LazyRender } from "sb-resp-ui";
import { EventsFromTopLeaguesBySportIdRequest } from "sb-bff-integration";
var RenderEvents = /** @class */ (function (_super) {
    __extends(RenderEvents, _super);
    function RenderEvents() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RenderEvents.prototype.render = function () {
        var view = [];
        var eventsLength = this.props.events.length;
        var eventToShow = Math.min(eventsLength, this.props.cms.ExpandedEvents);
        var currChunk = 0;
        for (var current = 0; current < eventToShow;) {
            var baseMinHeight = this.props.eventChunkHeights[currChunk++];
            var start = current;
            var max = current + this.props.state.EVENTS_CHUNK_SIZE;
            current = Math.min(max, eventToShow);
            view.push(React.createElement(LazyRender, { baseMinHeight: baseMinHeight, key: "k-lazy-" + current, observerOptions: {
                    threshold: 0,
                    rootMargin: "100px 0px"
                } }, renderInternalEvents(this.props.state, current, start, this.props.events, this.props.cms, this.props.dict)));
        }
        var filteredEvents = this.props.events.filter(function (x) { return x.type === EventsFromTopLeaguesBySportIdRequest.EventTypesEnum.Outright.toString(); });
        eventToShow < eventsLength && !this.props.cms.ShowViewAllLive && !filteredEvents.length && view.push(this.props.children);
        return view;
    };
    return RenderEvents;
}(React.PureComponent));
export { RenderEvents };
//# sourceMappingURL=RenderEvents.js.map